import React from 'react';

import Hero from './Hero/Hero';
import SupportChannels from './SupportChannels/SupportChannels';
import SupervisedEntity from './SupervisedEntity/SupervisedEntity';
import DoubtsCarousel from './DoubtsCarousel/DoubtsCarousel';
import FAQ from './FAQ/FAQ';
import Security from './Security/Security';
import NuCommunity from './NuCommunity/NuCommunity';

function Atencion() {
  return (
    <>
      <Hero />
      <SupportChannels />
      <SupervisedEntity />
      <DoubtsCarousel />
      <FAQ />
      <Security />
      <NuCommunity />
    </>
  );
}

export default Atencion;
